import { render, staticRenderFns } from "./FilterAddModal.vue?vue&type=template&id=bf226134&scoped=true&"
import script from "./FilterAddModal.vue?vue&type=script&setup=true&lang=ts&"
export * from "./FilterAddModal.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf226134",
  null
  
)

export default component.exports